import React, { useEffect } from 'react'
import { Alert, Box, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import LoginComponent from './Login.component'
import { useAuth } from '../../components/AuthContext/AuthProvider'
import { AuthCredentials } from '../../components/AuthContext/types'
import { MainPageBox } from '../../components/DisplayHelpers/MainPageBox'
import { APP_PATHS } from '../../components/AppRouter/types'
import {
  sendTrackingEvent,
  toButtonEvent,
  toScreenEvent
} from '../../services/amplitude.service'
import { LoginButtonEvent, ScreenOpendedEvent } from './types'

const LoginSignUpContainer: React.FC = (): JSX.Element => {
  const { login, user, loading, authError } = useAuth()
  const navigate = useNavigate()

  sendTrackingEvent(toScreenEvent(ScreenOpendedEvent))

  const handleOnSubmit = (data: AuthCredentials) => {
    sendTrackingEvent(toButtonEvent({ ...LoginButtonEvent }))
    login(data)
  }

  useEffect(() => {
    if (user && !loading) {
      navigate(APP_PATHS.APPLICATION, { replace: true })
    }
  }, [user])

  return (
    <MainPageBox>
      <Paper
        elevation={2}
        sx={{
          maxWidth: 600,
          minWidth: 300,
          pb: 2.5
        }}
      >
        <Box sx={{ p: 5 }}>
          <LoginComponent onSubmit={handleOnSubmit} loading={loading} />

          <Box sx={{ marginTop: 2 }}>
            {authError && <Alert severity="error">{authError}</Alert>}
          </Box>
        </Box>
      </Paper>
    </MainPageBox>
  )
}

export default LoginSignUpContainer
